import { useState, useEffect } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import styled from '@mui/material/styles/styled';
import InfoIcon from '@mui/icons-material/Info';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

const CustomWidthTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 600,
    fontWeight: 'normal'
  }
});

export default function CsTooltip({ value, tooltipText }) {
  const isMobile = useMediaQuery('(max-width:600px)');
  const [open, setOpen] = useState(false);

  const handleTooltipClick = () => {
    if (isMobile) {
      setOpen(!open);
    }
  };

  const handleTooltipHover = () => {
    if (!isMobile) {
      setOpen(true);
    }
  };

  const handleTooltipClose = () => {
    if (!isMobile) {
      setOpen(false);
    }
  };

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        setOpen(false);
      }, 7000)
    }
  }, [open])

  return (
    <CustomWidthTooltip
      title={tooltipText}
      open={open}
      onClose={handleTooltipClose}
      disableHoverListener={!isMobile}
    >
      <InfoIcon
        sx={{
          fontSize: '20px',
          verticalAlign: 'middle',
          cursor: 'pointer',
          color: '#6d4cb1'
        }}
        onClick={handleTooltipClick}
        onMouseEnter={handleTooltipHover}
        onMouseLeave={handleTooltipClose}
      />
    </CustomWidthTooltip>
  );
}
